import config from "./config";
var axios = config();
export default {
  getCurrentAndFutureTerms() {
    return axios.get("/api/TimePeriods/GetTermsCurrentAndFuture");
  },
  getTermsActive() {
    return axios.get("/api/TimePeriods/GetTermsActive", {});
  },
  getPastTerms() {
    return axios.get("/api/TimePeriods/GetTermsPast", {});
  }
};
